import React, { FC, useState } from 'react';
import { MdHistory as HistoryIcon } from '@react-icons/all-files/md/MdHistory';
import { createUseStyles } from 'src/theming';
import { IconButton } from '@material-ui/core';
import HistoryDialog from './components/HistoryDialog';
import { LegacyDeal } from 'src/interfaces/api/Deal';
import useAuth from 'src/hooks/api/useAuth';

interface Props {
  name: 'commerceInfos' | 'productionInfos' | 'installationInfos';
  fieldValue: string;
  dealId: LegacyDeal['id'];
  placeholder?: string;
  onValueChange?: (value: string) => void;
  label?: string;
}

const useStyles = createUseStyles({
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
});

const InfoField: FC<Props> = ({ name, label, dealId, onValueChange, fieldValue, placeholder }) => {
  const [value, setValue] = useState(fieldValue);
  const [, setError] = useState<string>();
  const [isHistoryDialogOpened, setIsHistoryDialogOpened] = useState(false);
  const { fetch } = useAuth();
  const classes = useStyles();

  const saveNewInfos = () => {
    fetch(`/api/deal/${dealId}/infos`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({ name, value }),
    })
      .then((resp) => resp.json())
      .then((response) => {
        if (response.success) {
          onValueChange && onValueChange(value);
        }
      })
      .catch((error) => {
        setError(error.message);
      });
  };

  return (
    <div className='form-group'>
      <div className={classes.titleContainer}>
        <div>{label}</div>
        <IconButton size='small' onClick={() => setIsHistoryDialogOpened(true)}>
          <HistoryIcon size={20} />
        </IconButton>
      </div>

      <textarea
        className='form-control'
        onChange={(event) => setValue(event.target.value)}
        placeholder={placeholder}
        value={value || ''}
        rows={5}
      />

      {value !== fieldValue && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10 }}>
          <button type='button' onClick={saveNewInfos} className='btn btn-xl btn-success'>
            Enregistrer
          </button>
        </div>
      )}

      <HistoryDialog
        open={isHistoryDialogOpened}
        onClose={() => setIsHistoryDialogOpened(false)}
        dealId={dealId}
        type={name}
      />
    </div>
  );
};

export default InfoField;
